var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.79073 3.50452L2.99573 2.29952C3.08311 2.21216 3.20161 2.16309 3.32517 2.16309C3.44873 2.16309 3.56723 2.21216 3.65461 2.29952L6.25752 4.90243C6.34488 4.98981 6.39395 5.10831 6.39395 5.23187C6.39395 5.35543 6.34488 5.47393 6.25752 5.56131L5.05252 6.76631C4.96514 6.85367 4.84664 6.90274 4.72308 6.90274C4.59952 6.90274 4.48102 6.85367 4.39364 6.76631L1.79073 4.1634C1.70337 4.07602 1.6543 3.95752 1.6543 3.83396C1.6543 3.7104 1.70337 3.5919 1.79073 3.50452Z",
    stroke: "#B0B7C3",
    strokeWidth: 0.652359,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85885 5.23145L1.46094 6.62936L2.85885 8.02727L4.25676 6.62936",
    stroke: "#B0B7C3",
    strokeWidth: 0.652359,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72266 3.36764L6.12057 1.96973L7.51848 3.36764L6.12057 4.76555",
    stroke: "#B0B7C3",
    strokeWidth: 0.652359,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6543 6.16309L6.35325 6.86204",
    stroke: "#B0B7C3",
    strokeWidth: 0.652359,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82031 8.49305C7.12927 8.49305 7.42557 8.37032 7.64404 8.15185C7.86251 7.93339 7.98524 7.63708 7.98524 7.32812",
    stroke: "#B0B7C3",
    strokeWidth: 0.652359,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05273 10.3573C7.79423 10.3573 8.50536 10.0628 9.02968 9.53847C9.554 9.01415 9.84856 8.30302 9.84856 7.56152",
    stroke: "#B0B7C3",
    strokeWidth: 0.652359,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSat);
export default __webpack_public_path__ + "static/media/sat.be171d8e9e8bbb0a82a67d944d6caa26.svg";
export { ForwardRef as ReactComponent };